import { skipAnalyticsForLocationTypeFilter } from "actions/locationFinder";
import { actions } from "@ehi/global-marketing-interface";
import { clearVehiclesFilterData } from "actions/vehicleClass";

export const handleClearAllFilter = (storeKey, locationTypeFilter) => dispatch => {
    dispatch(skipAnalyticsForLocationTypeFilter(true));
    dispatch(actions.setFiltersUiByKey(storeKey, []));
    if (locationTypeFilter) {
        dispatch(clearVehiclesFilterData());
    }
}